import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {ActionBox} from 'shells/action-box/action-box';
import {ActionMenu} from 'shells/action-menu/action-menu';
import type {SelectMenuOption} from 'shells/action-menu/action-menu';
import {Link} from 'shells/link/link';

import {AudienceArchivedTime} from './audience-archived-time';
import {AudienceLastContactedTime} from './audience-last-contacted-time';
import {getAudienceSubtitle} from './helpers';

import styles from './audience-list-item.module.css';

type Props = {
    deletedTime: number | null | undefined;
    lastContactedTime: number | null | undefined;
    htmlUrlPath: string;
    name: string;
    actionMenuOptions: SelectMenuOption[];
    subscribersCount: number | null | undefined;
    isPublic: boolean;
};

export function AudienceListItem(props: Props) {
    return (
        <ActionBox
            title={
                props.deletedTime ? (
                    <div className='light-text'>{props.name}</div>
                ) : (
                    // @ts-expect-error
                    <Link as={RouterLink} variant='primary' size='normal' to={props.htmlUrlPath}>
                        {props.name}
                    </Link>
                )
            }
            subtitle={getAudienceSubtitle({
                subscribersCount: props.subscribersCount,
                isPublic: props.isPublic,
                deletedTime: props.deletedTime,
            })}
            actionElement={
                <div className={styles['action-element']}>
                    {props.deletedTime ? (
                        <AudienceArchivedTime archivedTime={props.deletedTime} />
                    ) : (
                        <AudienceLastContactedTime lastContactedTime={props.lastContactedTime} />
                    )}

                    <ActionMenu options={props.actionMenuOptions} />
                </div>
            }
            size='small'
        />
    );
}
